var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("k-table", {
        attrs: {
          path: _vm.path,
          createButton: false,
          editButton: false,
          deleteButton: false,
          columns: [
            {
              display: "Código",
              value: "codigo"
            },
            {
              display: "Sucursal",
              value: "bodega.descripcion"
            },
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Recaudador",
              value: "descripcion_recaudador"
            },
            {
              display: "Creador",
              value: "creador.nombre"
            },
            {
              display: "Creación",
              value: "created_at"
            },
            {
              display: "Modificador",
              value: "modificador.nombre"
            },
            {
              display: "Modificación",
              value: "updated_at"
            }
          ]
        },
        on: { seleccionar: _vm.seleccionarRuta }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            attrs: { type: "button" },
            on: { click: _vm.cerrar }
          },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Listado de rutas")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c97c99e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c97c99e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/ListaRutas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9c97c99e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/ListaRutas.vue
// module chunks = 0